import React from "react";

/**
 * "Bill To" toggle placed inside the Company Details / Personal Details sections of the client
 * forms. The two switches are mutually exclusive: the client is billed either as its company or as
 * the person, or (both off) invoices go to a Bill To picked from the list.
 *
 * @param {object} props
 * @param {"Company"|"Individual"} props.kind - which switch this is
 * @param {""|"Company"|"Individual"} props.value - current selection
 * @param {(next: ""|"Company"|"Individual") => void} props.onChange
 * @param {boolean} [props.disabled]
 * @param {string} [props.disabledReason] - tooltip when disabled
 */
function BillToSelfSwitch({ kind, value, onChange, disabled = false, disabledReason }) {
  const on = value === kind;
  const other = kind === "Company" ? "Individual" : "Company";
  const label = kind === "Company" ? "Bill To this company" : "Bill To this person";
  let text;
  if (on) text = kind === "Company" ? "Invoices to the company" : "Invoices to the person";
  else if (value === other) text = kind === "Company" ? "Billing the person" : "Billing the company";
  else text = "Off";

  return (
    <div className="form-group bill-to-self">
      <label>{label}</label>
      <label
        className={`primary-switch ${on ? "is-on" : ""} ${disabled ? "is-locked" : ""}`}
        title={disabled ? disabledReason : undefined}
      >
        <input
          type="checkbox"
          checked={on}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked ? kind : "")}
        />
        <span className="primary-switch__track" aria-hidden="true">
          <span className="primary-switch__thumb" />
        </span>
        <span className="primary-switch__text">{text}</span>
      </label>
    </div>
  );
}

export default BillToSelfSwitch;
